module.exports = __webpack_public_path__ + "static/media/ic-shape.a98e6c75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Svgs/ic-shape.svg
// module id = 531
// module chunks = 0